import React from 'react';
import './Hero.css';

const Hero = () => {
  // const heroStyle = {
  //   backgroundImage: `url(${process.env.PUBLIC_URL}/images/image.png)`,
  //   backgroundSize: 'cover',
  //   backgroundPosition: 'center',
  //   backgroundRepeat: 'no-repeat',
  // };

  const heroStyle = {
    backgroundImage: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url(${process.env.PUBLIC_URL}/images/image.png)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  };
  
  return (
    <section className="hero" style={heroStyle}>
      <div className="hero-content">
        <h1 className="hero-title">Welcome to Moonstone Estate</h1>
        <p className="hero-subtitle">
          Premium Real Estate Development in Port Harcourt
        </p>
        <p className="hero-description">
          Discover luxury living and smart investment opportunities with Moonstone Estate Port Harcourt. 
          A premier development by GTEXT LAND featuring modern infrastructure, smart technology, 
          and strategic location for modern living and long-term value.
        </p>
      </div>
    </section>
  );
};

export default Hero;

